import React from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';
/* eslint-disable import/no-duplicates -- same image per slide until new banner assets */
import bannerDesktop1 from 'assets/images/banner-desktop-2.jpg';
import bannerDesktop2 from 'assets/images/banner-desktop-2.jpg';
import bannerDesktop3 from 'assets/images/banner-desktop-2.jpg';
/* eslint-enable import/no-duplicates */
import { motion } from 'framer-motion';

const MotionFlex = motion(Flex);

const Banner: React.FC = () => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const images = [
    { desktop: bannerDesktop2, mobile: bannerDesktop2 },
    { desktop: bannerDesktop1, mobile: bannerDesktop1 },
    { desktop: bannerDesktop3, mobile: bannerDesktop3 },
  ];

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box position="relative" width="full" overflow="hidden">
      <MotionFlex
        width="full"
        animate={{ x: `-${currentIndex * 100}%` }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
      >
        {images.map((src, index) => (
          <Box key={index} flex="0 0 100%">
            <Image
              src={src.mobile}
              alt={`Slide ${index}`}
              width="100%"
              h={{ base: '70px', md: '160px' }}
              objectFit="cover"
              borderRadius={8}
              display={{ base: 'block', lg: 'none' }}
            />
            <Image
              src={src.desktop}
              alt={`Slide ${index}`}
              width="100%"
              h={{ base: '70px', md: '160px' }}
              objectFit="cover"
              borderRadius={8}
              display={{ base: 'none', lg: 'block' }}
            />
          </Box>
        ))}
      </MotionFlex>
    </Box>
  );
};

export default Banner;
